<template>
  <div class=" feedback-page page-padding-top">
    <top-bar :title="i18n.t('feedback.title')" @back="back"></top-bar>

    <div class="feedback-main">
      <div class="top-info flex-column-center">
        <img :src="logoUrl" alt="">
        <div >{{i18n.t('feedback.desc1')}}</div>
      </div>

      <div class="title">{{$t('feedback.title1')}}</div>
      <div class="content" :class="inputActive ? 'active' : ''">
        <Field
          v-model="message"
          class="content-field"
          label=""
          type="textarea"
          @focus="inputActive = true"
          @blur="inputActive = false"
          maxlength="500"
          :placeholder="i18n.t('feedback.placeholder')"
          show-word-limit
        />
      </div>


      <div class="title">{{$t('feedback.title2')}} ({{fileList.length}}/3)</div>
      <div class="file-btn">
        <Uploader
          v-model="fileList"
          :before-read="doUpload" 
          max-count="3"
        ></Uploader>
      </div>

     

      <div class="bottom-btn">
        <div class="btn">
          <Button @click="toTrade">{{i18n.t('feedback.btn2')}}</Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topBar from '@/components/topBar'
import { Button, Search, Icon, Field, Uploader  } from 'vant'
import { uploadFile } from '@/api/setting'
export default {
  components: {
    Button,
    Search,
    Icon,
    Field,
    Uploader,
    topBar
  },
  data() {
    return {
      message: '',
      logoUrl:require('../../assets/imgs/logo.png'),
      uploadUrl:require('../../assets/imgs/icon-upload.png'),
      emptyUrl:require('../../assets/imgs/order-empty.png'),
      feedbackValue: 10,
      fileName: '',
      fileList: [],
      inputActive: false
    }
  },
  mounted() {
  },
  methods: {
    init() {
    
    },
    back() {
      this.$router.go(-1)
    },
    changeValue(val) {
      this.feedbackValue = val
    },
    addFile() {
      document.getElementById('fileInput').click()
    },
    chooseFile(e) {
      let file = e.target.files[0]
      let name = file.name
      this.fileName = name
    },
    submit() {
      this.$store.state.successMsg = this.i18n.t('feedback.success')
      setTimeout(() => {
        this.back()
      }, 1000)
    },
    toTrade() {
      this.$router.push({
        name: 'trade'
      })
    },
    doUpload(file) {
      return file
      let form = new FormData()
      form.append('file', file)
      return new Promise((resolve, reject) => {
        uploadFile(form).then(res => {
          if (res.code == 0) {
            resolve(file)
          } else {
            this.$toast(this.$t('feedback.error'))
            reject()
          }
        }).catch(e => {
          this.$toast(this.$t('feedback.error'))
          reject()
        })
      })
    },
  }
}
</script>